<template>
    <div class="workordrAssign" style="margin-bottom:12px">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i> 审核承办单位的退回指挥中心申请
        </div>
        <div class="workordr_content">
            <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>退回申请</p>
                </div>
            </div>
            <div v-for="(item ,index) in queryWordorderMessageData">
                <div class="workordr_result">
                    <div class="workordr_result_title">
                        <span class="icon-build"></span>
                        <span>
                       {{item.czCzdwmc}}
                    </span>
                        <span><el-icon><clock/></el-icon></span>
                        <span>
                       {{item.updateTime}}
                    </span>
                    </div>
                    <!--<div class="workordr_result_main">-->
                    <!--{{item.czCzjgwb}}-->
                    <!--</div>-->
                </div>
                <div class="workordr_result workordr_resultReview">
                    <div class="workordr_resultReview_list">
                        <div class="workordr_resultReview_label">
                            退回原因：
                        </div>
                        <div class="workordr_resultReview_textarea">
                            {{item.czCzjgwb}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <el-form label-width="100px"
             :model="ruleForm"
             :rules="rules"
             label-position="left"
             ref="ruleFormRef">
        <div class="workordrAssign">
            <div class="workordr_content">
                <div class="workordr_content_title">
                    <div class="workordr_content_title_left">
                        <span></span>
                        <p>审核结果</p>
                        <el-radio-group v-model="ruleForm.czCzjgzt">
                            <el-radio-button label="1">通过</el-radio-button>
                            <el-radio-button label="0">驳回</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div class="workordr_main">
                    <el-form-item label="驳回原因" prop="czCzjgwb" v-if="ruleForm.czCzjgzt=='0'">
                        <el-input v-model="ruleForm.czCzjgwb" :autosize="{ minRows: 5}" maxlength="2000" placeholder="请输入" show-word-limit
                                  type="textarea"/>
                    </el-form-item>
                    <!--<Workorder_file paddingLeft="100" @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>-->
                </div>
            </div>
        </div>
        <el-form-item class="workordrAssign_btn">
            <div class="workordrAssign_btn_cancle" @click="cancleClick">
                取消
            </div>
            <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                确认
            </div>
        </el-form-item>
    </el-form>
</template>

<script>
    //退回审核
    import {reactive, computed, ref, getCurrentInstance, onMounted} from 'vue'
    import {ElMessageBox,ElLoading} from 'element-plus'
    import {useStore} from 'vuex';
    import Workorder_file from './Wordorder_file.vue';

    export default {
        name: "WorkorderReturnReview",
        props: ["gdId"],
        components: {
            Workorder_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleFormRef = ref()
            const ruleForm = reactive({
                "czCzlx": 'THSH',
                "gdId": props.gdId,
                "czCzjgzt": "1",
                "czCzjgwb": "",
                // "fileIds":[]
            });
            const rules = reactive({
                czCzjgwb: [
                    {required: true, message: "请输入驳回原因", trigger: 'blur'},
                ]
            });
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if (action == "confirm") {
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent");
                                        store.state.addNewWorkorderSuccess=true;
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            let queryWordorderMessageData = ref()
            onMounted(() => {
                // queryWordorderMessage();
            })
            const queryWordorderMessage = () => {
                proxy.$axios.post("/jgfast/wgsj/selBshczsj", {
                    "gdId": props.gdId,
                }).then((res) => {
                    queryWordorderMessageData.value = res.data;
                });
            }
            //取消事件
            const cancleClick = () => {
                context.emit("workorderCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if (action == "confirm") {
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })
            }
            const fileListToParent=(param)=>{
                if(param){
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile=(param)=>{
                ruleForm.fileIds.splice(param, 1)
            }
            return {
                ruleForm,
                ruleFormRef,
                rules,
                submitForm,
                queryWordorderMessageData,
                cancleClick,
                fileListToParent,
                deleteFile
            }
        }
    }
</script>

<style scoped>

</style>
